import authList from 'sd-auth-list';
import GOP from 'sd-onepass';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/* eslint-disable */
//https://github.com/florian/cookie.js
var cookie = function cookie() {
  return cookie.get.apply(cookie, arguments);
};

var utils = cookie.utils = {
  // Is the given value an array? Use ES5 Array.isArray if it's available.
  isArray: Array.isArray || function (value) {
    return Object.prototype.toString.call(value) === '[object Array]';
  },
  // Is the given value a plain object / an object whose constructor is `Object`?
  isPlainObject: function isPlainObject(value) {
    return !!value && Object.prototype.toString.call(value) === '[object Object]';
  },
  // Convert an array-like object to an array – for example `arguments`.
  toArray: function toArray(value) {
    return Array.prototype.slice.call(value);
  },
  // Get the keys of an object. Use ES5 Object.keys if it's available.
  getKeys: Object.keys || function (obj) {
    var keys = [],
        key = '';

    for (key in obj) {
      if (obj.hasOwnProperty(key)) keys.push(key);
    }

    return keys;
  },
  // Unlike JavaScript's built-in escape functions, this method
  // only escapes characters that are not allowed in cookies.
  encode: function encode(value) {
    return String(value).replace(/[,;"\\=\s%]/g, function (character) {
      return encodeURIComponent(character);
    });
  },
  decode: function decode(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
      return value;
    }
  },
  // Return fallback if the value is not defined, otherwise return value.
  retrieve: function retrieve(value, fallback) {
    return value == null ? fallback : value;
  }
};
cookie.defaults = {};
cookie.expiresMultiplier = 60 * 60 * 24;

cookie.set = function (key, value, options) {
  if (utils.isPlainObject(key)) {
    // `key` contains an object with keys and values for cookies, `value` contains the options object.
    for (var k in key) {
      if (key.hasOwnProperty(k)) this.set(k, key[k], value);
    }
  } else {
    options = utils.isPlainObject(options) ? options : {
      expires: options
    }; // Empty string for session cookies.

    var expires = options.expires !== undefined ? options.expires : this.defaults.expires || '',
        expiresType = _typeof(expires);

    if (expiresType === 'string' && expires !== '') expires = new Date(expires);else if (expiresType === 'number') expires = new Date(+new Date() + 1000 * this.expiresMultiplier * expires); // This is needed because IE does not support the `max-age` cookie attribute.

    if (expires !== '' && 'toGMTString' in expires) expires = ';expires=' + expires.toGMTString();
    var path = options.path || this.defaults.path;
    path = path ? ';path=' + path : '';
    var domain = options.domain || this.defaults.domain;
    domain = domain ? ';domain=' + domain : '';
    var secure = options.secure || this.defaults.secure ? ';secure' : '';
    if (options.secure === false) secure = '';
    document.cookie = utils.encode(key) + '=' + utils.encode(value) + expires + path + domain + secure;
  }

  return this; // Return the `cookie` object to make chaining possible.
};

cookie.setDefault = function (key, value, options) {
  if (utils.isPlainObject(key)) {
    for (var k in key) {
      if (this.get(k) === undefined) this.set(k, key[k], value);
    }

    return cookie;
  } else {
    if (this.get(key) === undefined) return this.set.apply(this, arguments);
  }
}, cookie.remove = function (keys) {
  keys = utils.isArray(keys) ? keys : utils.toArray(arguments);

  for (var i = 0, l = keys.length; i < l; i++) {
    this.set(keys[i], '', -1);
  }

  return this; // Return the `cookie` object to make chaining possible.
};

cookie.removeSpecific = function (keys, options) {
  if (!options) return this.remove(keys);
  keys = utils.isArray(keys) ? keys : [keys];
  options.expire = -1;

  for (var i = 0, l = keys.length; i < l; i++) {
    this.set(keys[i], '', options);
  }

  return this; // Return the `cookie` object to make chaining possible.
};

cookie.empty = function () {
  return this.remove(utils.getKeys(this.all()));
};

cookie.get = function (keys, fallback) {
  var cookies = this.all();

  if (utils.isArray(keys)) {
    var result = {};

    for (var i = 0, l = keys.length; i < l; i++) {
      var value = keys[i];
      result[value] = utils.retrieve(cookies[value], fallback);
    }

    return result;
  } else return utils.retrieve(cookies[keys], fallback);
};

cookie.all = function () {
  if (document.cookie === '') return {};
  var cookies = document.cookie.split('; '),
      result = {};

  for (var i = 0, l = cookies.length; i < l; i++) {
    var item = cookies[i].split('=');
    var key = utils.decode(item.shift());
    var value = utils.decode(item.join('='));
    result[key] = value;
  }

  return result;
};

cookie.enabled = function () {
  if (navigator.cookieEnabled) return true;
  var ret = cookie.set('_', '_').get('_') === '_';
  cookie.remove('_');
  return ret;
}; // If an AMD loader is present use AMD.
// If a CommonJS loader is present use CommonJS.
// Otherwise assign the `cookie` object to the global scope.


if (typeof define === 'function' && define.amd) {
  define(function () {
    return cookie;
  });
} else if (typeof exports !== 'undefined') {
  exports.cookie = cookie;
} else window.cookie = cookie; // module.exports = cookie;

var urlParam = function urlParam(name, url) {
  var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url || window.location.href);

  if (!results) {
    return '';
  }

  return results[1] || '';
};
var updateQueryStringParameter = function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';

  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
};
var getDomain = function getDomain() {
  var domainArr = window.document.domain.split('.');
  return ".".concat(domainArr[domainArr.length - 2], ".").concat(domainArr[domainArr.length - 1]);
};
var getUrlOrigin = function getUrlOrigin(url) {
  return /^https?:\/\/[\w-.]+(:\d+)?/i.exec(url) ? /^https?:\/\/[\w-.]+(:\d+)?/i.exec(url)[0] : '';
};
var stringify = function stringify(obj, sep, eq, name) {
  var stringifyPrimitive = function stringifyPrimitive(v) {
    switch (_typeof(v)) {
      case 'string':
        return v;

      case 'boolean':
        return v ? 'true' : 'false';

      case 'number':
        return isFinite(v) ? v : '';

      default:
        return '';
    }
  };

  sep = sep || '&';
  eq = eq || '=';

  if (obj === null) {
    obj = undefined;
  }

  if (_typeof(obj) === 'object') {
    return Object.keys(obj).map(function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;

      if (Array.isArray(obj[k])) {
        return obj[k].map(function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};
var clearUrl = function clearUrl(url) {
  var urlspLit = url.split('?');

  if (!urlspLit[1]) {
    return url + '?a=b';
  }

  var params = urlspLit[1].split('&').filter(function (v) {
    var pList = ['code', 'state', 'reloadId', 'token', 'refreshToken', 'statusCode', 'isBindMobile', 'userId', 'cryptoUserId'];
    return pList.every(function (value) {
      return v.indexOf(value) < 0;
    });
  });
  return "".concat(urlspLit[0], "?").concat(params.join('&'));
};
var reloadPage = function reloadPage() {
  var currentPageUrl = clearUrl(window.location.href);
  var flag = currentPageUrl.indexOf('?') > -1 ? '&' : '?';
  window.location.replace("".concat(currentPageUrl).concat(flag, "reloadId=") + (Math.random() * 10000).toFixed(0));
};
var maxCount = 3;
var maxCountReloadPage = function maxCountReloadPage() {
  var loc = window.location;
  var currentPageUrl = clearUrl(loc.href);
  var flag = currentPageUrl.indexOf('?') > -1 ? '&' : '?';
  var urlCount = urlParam('__c__');
  var count = urlCount ? Number(urlCount) : 0;

  if (count < maxCount) {
    var originUrl = "".concat(currentPageUrl).concat(flag, "reloadId=") + (Math.random() * 10000).toFixed(0);
    loc.replace(updateQueryStringParameter(originUrl, '__c__', ++count));
  }
};
var createIframe = function createIframe(src, domain, callback) {
  var win = window;
  var doc = win.document;
  var iframe = doc.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = src;

  var onMessage = function onMessage(event) {
    var origin = event.origin || event.originalEvent.origin;
    if (origin !== domain) return;
    win.removeEventListener('message', onMessage);
    iframe.remove();
    callback();
  };

  win.addEventListener('message', onMessage, false);
  doc.body.appendChild(iframe);
};
var isWiFiUserOfBD = function isWiFiUserOfBD() {
  var _navigator = navigator,
      userAgent = _navigator.userAgent;

  if (userAgent.toLowerCase().indexOf('nettype/wifi') > 0) {
    return true;
  } else {
    // if not WiFi or
    var _navigator2 = navigator,
        connection = _navigator2.connection;

    if (connection) {
      var type = connection.type;

      if (type) {
        if (type.toLowerCase() === 'wifi') {
          return true;
        }
      }
    }
  }

  return false;
};
var createDelayPromise = function createDelayPromise(ms) {
  return new Promise(function (resolve, reject) {
    var ermsg = {
      code: 20903,
      msg: '接口操作时长超时操作超时！'
    };
    setTimeout(function () {
      reject(ermsg);
    }, ms);
  });
};

// chengkebin@shuidihuzhu.com
cookie.defaults = {
  expires: 365,
  domain: getDomain(),
  path: '/'
};
var storage = {
  get: function get(key) {
    return cookie.get(key);
  },
  set: function set(option, domain) {
    Object.keys(option).forEach(function (v) {
      cookie.set(v, option[v], {
        domain: domain
      });
    });
  },
  del: function del(key) {
    cookie.set(key, null);
    cookie.remove(key);
  }
};

/**
 * @author  walid
 * @version 2.0 | 2016-11-30
 * @description  展示容器平台工具类
 */
var showPlatformEnum = {
  WECHAT: 1,
  BROWSER: 2,
  ANDROID: 3,
  IOS: 4
};

var getShowPlatform = function getShowPlatform(allowWechatMiniProgram) {
  var ua = window.navigator.userAgent.toLowerCase();
  var wechatMiniSwitch = allowWechatMiniProgram ? true : window.__wxjs_environment !== 'miniprogram'; // 微信或者企业微信

  if (/micromessenger/i.test(ua) && !/wxwork/i.test(ua) && wechatMiniSwitch) {
    return showPlatformEnum.WECHAT;
  }

  if (/rock\//i.test(ua) && /Android/i.test(ua)) {
    return showPlatformEnum.ANDROID;
  }

  if (/rock\//i.test(ua) && /iPhone\sOS/i.test(ua)) {
    return showPlatformEnum.IOS;
  }

  return showPlatformEnum.BROWSER;
};

var platform = {
  getShowPlatform: getShowPlatform,
  showPlatformEnum: showPlatformEnum
};

(function (self) {
  //   return
  // }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && function () {
      try {
        new Blob();
        return true;
      } catch (e) {
        return false;
      }
    }(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  if (support.arrayBuffer) {
    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

    var isDataView = function isDataView(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj);
    };

    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }

    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }

    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }

    return value;
  } // Build a destructive iterator for the value list


  function iteratorFor(items) {
    var iterator = {
      next: function next() {
        var value = items.shift();
        return {
          done: value === undefined,
          value: value
        };
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ',' + value : value;
  };

  Headers.prototype['delete'] = function (name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items = [];
    this.forEach(function (value) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'));
    }

    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };

      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }

    return chars.join('');
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
      this._bodyInit = body;

      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer); // IE 10-11 can't handle a DataView body.

        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        throw new Error('unsupported BodyInit type');
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);

        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    this.text = function () {
      var rejected = consumed(this);

      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }

    this.json = function () {
      return this.text().then(JSON.parse);
    };

    return this;
  } // HTTP methods whose capitalization should be normalized


  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read');
      }

      this.url = input.url;
      this.credentials = input.credentials;

      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }

      this.method = input.method;
      this.mode = input.mode;

      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'omit';

    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }

    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }

    this._initBody(body);
  }

  Request.prototype.clone = function () {
    return new Request(this, {
      body: this._bodyInit
    });
  };

  function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function (bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form;
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers(); // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2

    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
      var parts = line.split(':');
      var key = parts.shift().trim();

      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';

    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    });
  };

  Response.error = function () {
    var response = new Response(null, {
      status: 0,
      statusText: ''
    });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    return new Response(null, {
      status: status,
      headers: {
        location: url
      }
    });
  };

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.sdfetch = function (input, init) {
    return new Promise(function (resolve, reject) {
      var request = new Request(input, init);
      var xhr = new XMLHttpRequest();

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });
      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  };

  self.sdfetch.polyfill = true;
})(typeof self !== 'undefined' ? self : window);

var baseURL = '//passport.shuidihuzhu.com';
var setBaseUrl = function setBaseUrl(url) {
  baseURL = url;
};
var crossCookieKey = '';
var setCrossCookieKey = function setCrossCookieKey(key) {
  crossCookieKey = key;
};
var post = function post(url, body, header) {
  header = header || {};
  header = Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded'
  }, header);
  var requestData = {
    method: 'POST',
    mode: 'cors',
    cache: 'default',
    headers: header,
    body: stringify(body)
  };

  if (crossCookieKey && storage.get(crossCookieKey)) {
    requestData.credentials = 'include';
  }

  return new Promise(function (resolve, reject) {
    window.sdfetch("".concat(baseURL).concat(url), requestData).then(function (resp) {
      return Promise.all([resp.status, resp.json()]);
    }).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          status = _ref2[0],
          resp = _ref2[1];

      if (status >= 200 && status < 300) {
        return !resp.code || resp.code === 0 ? resolve(resp) : reject(resp);
      } else {
        reject(resp);
      }
    })["catch"](function (err) {
      if (err instanceof Error) {
        var name = err.name,
            message = err.message;
        var rejerr = {
          code: 20904,
          msg: "".concat(name, " : ").concat(message)
        };
        reject(rejerr);
      } else {
        var _rejerr = {
          code: 20904,
          msg: 'unknow error .'
        };
        reject(_rejerr);
      }
    });
  });
};

var requestUrl = function requestUrl(path) {
  return function (body, header) {
    return post(path, body, header);
  };
};

var http = {
  sendVerifyCode: requestUrl('/api/useraccount/sendVerifyCode'),
  sendVerifyCodeWithToken: requestUrl('/api/useraccount/sendVerifyCode-withToken'),
  checkVerifyCodeWithToken: requestUrl('/api/account/v2/checkVerifyCode-withToken'),
  bindMobile: requestUrl('/api/account/v2/bindMobile'),
  registAccountWithMobile: requestUrl('/api/account/v2/registerWithMobile'),
  refreshToken: requestUrl('/api/account/v2/refreshToken'),
  userInfo: requestUrl('/api/account/v2/userInfo'),
  log: requestUrl('/api/account/v2/log'),
  // 初始化图形验证码接口
  initCaptcha: requestUrl('/api/useraccount/start-captcha'),
  // 校验图形验证
  checkCaptcha: requestUrl('/api/useraccount/verify-graphic'),
  // 使用手机号+code（账号系统生成）登录
  loginByLongCode: requestUrl('/api/account/v2/loginByLongCode'),
  // 手机号换绑
  changeBind: requestUrl('/api/account/v2/change-bind-mobile'),
  // 获取seqNum
  getSeqNum: requestUrl('/api/account/v2/pre-mobile-url'),
  // 获取手机号
  getMobile: requestUrl('/api/account/v2/quick-get-mobile'),
  // 手机号一键登录
  oneClickLogin: requestUrl('/api/account/v2/quick-reg-login'),
  // 使用 onePass进行一键登录
  doOnePassLogin: requestUrl('/api/account/v2/oneClickLogin'),
  // 短信点击来源手机号免验证码登录
  smsPNDirectLogin: requestUrl('/api/account/v2/loginWithMsgLink'),
  // 是否绑定手机号
  isBindMobileAsync: requestUrl('/api/account/v2/isBindMobile'),
  // 是否登录
  isLoginAsync: requestUrl('/api/account/v2/isLogin'),
  // 一键登录自动化配置SDK接口
  getGeeConfig: requestUrl('/api/account/v2/getGeeConfig'),
  // 是否登录
  bindMobileWithGee: requestUrl('/api/account/v2/bindMobileWithGee'),
  // 获取微信公众号/小程序所有配置
  getAllWxConfig: requestUrl('/api/account/v2/getAllWxConfig'),
  // 根据thirdtype获取微信配置
  getWxConfigByThirdType: requestUrl('/api/account/v2/getWxConfigByThirdType')
};

var name = "sd-account";
var version = "6.3.0";
var description = "水滴登录模块";
var main = "./dist/sd-account.umd.dev.js";
var module = "./dist/sd-account.esm.dev.js";
var unpkg = "dist/sd-account.umd.prod.js";
var jsdelivr = "dist/sd-account.umd.prod.js";
var scripts = {
	lint: "standard --fix",
	ut: "NODE_ENV=test jest",
	build: "yarn ut && yarn lint  && node ./script/build.js",
	postpublish: "sd-publisher",
	version: "conventional-changelog -p angular -i CHANGELOG.md -s && git add CHANGELOG.md"
};
var repository = {
	type: "git",
	url: "http://gitlab.shuidihuzhu.com/fed_package/account.git"
};
var author = "chengkebin";
var license = "ISC";
var devDependencies = {
	"@babel/cli": "^7.8.3",
	"@babel/core": "^7.8.3",
	"@babel/plugin-transform-runtime": "^7.8.3",
	"@babel/preset-env": "^7.8.3",
	"@babel/runtime": "^7.8.3",
	"@rollup/plugin-commonjs": "^11.0.1",
	"@rollup/plugin-json": "^4.0.1",
	"@rollup/plugin-node-resolve": "^7.0.0",
	"babel-jest": "^24.9.0",
	"conventional-changelog-cli": "^2.0.21",
	"cz-conventional-changelog": "2.1.0",
	husky: "^1.2.1",
	rollup: "^1.27.14",
	"rollup-plugin-babel": "^4.3.3",
	"rollup-plugin-terser": "^5.2.0",
	standard: "^12.0.1"
};
var husky = {
	hooks: {
		"pre-commit": "npm run lint && npm run ut",
		"pre-push": "npm run lint && npm run ut && yarn version"
	}
};
var standard = {
	ignore: [
		"onepassh5.js",
		"fetch.js"
	],
	globals: [
		"Headers",
		"Request",
		"test",
		"expect"
	]
};
var dependencies = {
	"core-js": "^3.6.4",
	"sd-auth-list": "^0.0.7",
	"sd-onepass": "0.0.1"
};
var config = {
	commitizen: {
		path: "./node_modules/cz-conventional-changelog"
	}
};
var packageJSON = {
	name: name,
	version: version,
	description: description,
	main: main,
	module: module,
	unpkg: unpkg,
	jsdelivr: jsdelivr,
	scripts: scripts,
	repository: repository,
	author: author,
	license: license,
	devDependencies: devDependencies,
	husky: husky,
	standard: standard,
	dependencies: dependencies,
	config: config
};

var _window = window,
    localStorage = _window.localStorage;
var localData = {};

localData.getItem = function (key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return null;
  }
};

localData.setItem = function (key, value) {
  try {
    var stringifyValue = JSON.stringify(value);
    localStorage.setItem(key, stringifyValue);
    return stringifyValue;
  } catch (e) {
    return null;
  }
};

localData.removeItem = function (key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}; // 缓存，有效期默认15分钟


localData.getItemByTime = function (key) {
  var expires = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000 * 60 * 15;

  try {
    var data = localStorage.getItem(key);
    if (!data) return null;
    var dataObj = JSON.parse(data);

    if (new Date().getTime() - dataObj.time > expires) {
      localStorage.removeItem(key);
      return null;
    } else {
      return dataObj.data;
    }
  } catch (e) {
    return null;
  }
};

localData.setItemByTime = function (key, value) {
  try {
    var stringifyValue = JSON.stringify({
      data: value,
      time: new Date().getTime()
    });
    localStorage.setItem(key, stringifyValue);
    return stringifyValue;
  } catch (e) {
    return null;
  }
};

function appidEnum () {
  var useAuthList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var authType = '_sd_auth_config'; // useAuthList true 使用sd-auth-list中数据

  if (useAuthList) return authList;
  return new Promise(function (resolve, reject) {
    var cacheAuthConfig = localData.getItemByTime(authType); // 获取缓存 有效期15分钟

    if (cacheAuthConfig) {
      resolve(cacheAuthConfig);
      http.log({
        'log': JSON.stringify({
          'name': 'sd_account_sdk',
          'type': 'use_auth_cache',
          // 埋点统计获取缓存配置
          'sdk_version': packageJSON.version
        })
      });
      return;
    }

    http.getAllWxConfig().then(function (res) {
      localData.setItemByTime(authType, res.data); // 缓存

      resolve(_objectSpread2({}, authList, {}, res.data || {}));
      http.log({
        'log': JSON.stringify({
          'name': 'sd_account_sdk',
          'type': 'use_auth_config',
          // 埋点统计获取缓存配置
          'sdk_version': packageJSON.version
        })
      });
    })["catch"](function (e) {
      http.log({
        'log': JSON.stringify({
          'name': 'sd_account_sdk',
          'type': 'auth_config_error',
          // 埋点统计获取auth-list错误
          'msg': e.msg || e.message(),
          'sdk_version': packageJSON.version
        })
      });
      resolve(authList); // 降级使用sd-auth-list库
    });
  });
}

/**
 * @author  chengkebin@shuidihuzhu.com | jiwenbing@shuidihuzhu.com
 * @version 2.0 | 2016-11-22
 * @describe  通过需要跳转的URL，获取根据平台生成的URL
 * @example  var url = getWxRedirectUrl('http://www.shuidihuzhu.com');
 */
var getWxRedirectUrl = (function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    url: '',
    userThirdScope: 'base',
    thirdType: 17,
    allowWechatMiniProgram: false,
    appidAll: {}
  };
  var redirectUrl, scope;
  var appid = config.appidAll[config.thirdType] || appidEnum(true)[17];

  if (!config.url) {
    return;
  }

  if (platform.getShowPlatform(config.allowWechatMiniProgram) !== platform.showPlatformEnum.WECHAT) {
    return config.url;
  } // 跟据type来获取使用哪种方式来获取code


  scope = config.userThirdScope === 'base' ? 'snsapi_base' : 'snsapi_userinfo';
  redirectUrl = window.encodeURIComponent(clearUrl(config.url));
  return "https://open.weixin.qq.com/connect/oauth2/authorize?appid=".concat(appid, "&redirect_uri=").concat(redirectUrl, "&response_type=code&scope=").concat(scope, "&connect_redirect=1#wechat_redirect");
});

/**
 * @author  chengkebin@shuidihuzhu.com | jiwenbing@shuidihuzhu.com
 * @version 1.0 | 2016-11-24
 * @describe  存放业务常量
 * @example
 */
// 微信 scope
var thirdScope = {
  // 基本权限
  base: 'BASE',
  // 用户权限,可获取到
  user_info: 'USER_INFO'
};
var __oldCode = '__oldcode';
var sdKey = 'defaultConfig';
var bizType = {
  // 水滴互助
  shuidihuzhu: 'SDHZ',
  // 水滴筹
  shuidichou: 'SDCF',
  // 水滴保
  sdbao: 'SDB'
};

var ssoWaitTime = 3500;
var setSSOWaitTime = function setSSOWaitTime(time) {
  if (typeof time === 'number' && time > 0) {
    ssoWaitTime = time;
  }
};
var crossSiteCookie = (function () {
  var tokenData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var domainAuthStatus = {};
  var _options$needCommonFl = options.needCommonFlag,
      needCommonFlag = _options$needCommonFl === void 0 ? true : _options$needCommonFl,
      _options$needPayFlag = options.needPayFlag,
      needPayFlag = _options$needPayFlag === void 0 ? false : _options$needPayFlag;
  var domainList = ['.shuidihuzhu.com', '.shuidichou.com', '.sdbao.com', '.shuidigongyi.com', '.shuidigongyi.cn'].filter(function (v) {
    return v !== getDomain();
  });
  var promiseArr = needPayFlag ? [loadFrame("https://pay.shuidihuzhu.com/auth/")] : [];

  if (needCommonFlag) {
    domainList.forEach(function (value) {
      promiseArr.push(loadFrame("https://auth".concat(value)));
    });
  }

  function loadFrame(domain) {
    http.log({
      'log': JSON.stringify({
        'name': 'sd_account_sdk',
        'type': 'load_frame',
        'domain': domain,
        'sdk_version': packageJSON.version
      })
    });
    return new Promise(function (resolve, reject) {
      tokenData.domain = domain;
      var i = document.createElement('iframe');
      var src = "".concat(domain, "?").concat(stringify(tokenData));
      i.style.display = 'none';
      window.addEventListener('message', messageHandler, false);
      setTimeout(function () {
        resolve();
        i.remove();
        http.log({
          'log': JSON.stringify({
            'name': 'sd_account_sdk',
            'type': 'timeout_remove_frame',
            'domain': domain,
            'no_success': domainAuthStatus[domain] !== 'success',
            'sdk_version': packageJSON.version
          })
        });
      }, ssoWaitTime);
      i.src = src;
      document.body.appendChild(i);
      console.log(src);

      function messageHandler(e) {
        if (e.origin !== getUrlOrigin(domain)) return;
        console.log("".concat(domain, " sso suc"));
        resolve();
        i.remove(); // 跨域登录成功，和timeout_remove_frame/load_frame比较得出失败率

        domainAuthStatus[domain] = 'success';
        http.log({
          'log': JSON.stringify({
            'name': 'sd_account_sdk',
            'type': 'suc_remove_frame',
            'domain': domain,
            'sdk_version': packageJSON.version
          })
        });
        window.removeEventListener('message', messageHandler, false);
      }
    });
  }

  return Promise.all(promiseArr);
});

var noDebugFunc = function noDebugFunc() {};

var defaultDebugFunc = function defaultDebugFunc() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  console.log("[sd-account debug info] ".concat(args));
};

var __debug__ = noDebugFunc;
var persistDebugFunc = function persistDebugFunc(config) {
  var debug = config.debug,
      debugFunc = config.debugFunc;

  if (debug) {
    // user set debug mode
    if (debugFunc && typeof debugFunc === 'function') {
      __debug__ = debugFunc;
      return;
    }

    __debug__ = defaultDebugFunc;
  }
};

var tokenTimeListener = (function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(function (resolve, reject) {
    // 检测token是否过期，如果过期则重新获取token
    var token = storage.get('token');
    var refreshToken = storage.get('refreshToken');
    var now = new Date().valueOf();
    var timeStamp = storage.get('timeStamp');
    var comparison = now - Number(timeStamp) > 1000 * 3600 * 24 * 6;

    if (token && (!timeStamp || comparison)) {
      http.refreshToken({
        token: token,
        refreshToken: refreshToken
      }).then(function (res) {
        token = res.data.sdToken;
        refreshToken = res.data.refreshToken;
        var setOptions = {
          token: res.data.sdToken,
          refreshToken: res.data.refreshToken,
          isBindMobile: res.data.bindMobile,
          cryptoUserId: res.data.cryptoUserId,
          mobile: res.data.mobile,
          timeStamp: new Date().valueOf()
        };
        storage.set(setOptions); // 微信内只sso收银台，微信外执行收银台和业务sso

        var crossSiteCookieOpts = {
          needPayFlag: true
        };
        if (platform.getShowPlatform(config.allowWechatMiniProgram) === platform.showPlatformEnum.WECHAT) crossSiteCookieOpts.needCommonFlag = false;
        crossSiteCookie(setOptions, crossSiteCookieOpts).then(function () {
          resolve({
            token: token,
            refreshToken: refreshToken
          });
        });
      })["catch"](function () {
        storage.del('token');
        storage.del('tokenType');
        storage.del('refreshToken');
        storage.del('isBindMobile');

        __debug__('Delete Cookies of tokenTimeListener');

        resolve({
          token: undefined,
          refreshToken: undefined
        });
      });
    } else {
      resolve({
        token: token,
        refreshToken: refreshToken
      });
    }
  });
});

function getThirdCode () {
  // const { sessionStorage } = window
  // const oldCode = sessionStorage.getItem(thirdCode)
  var oldCode = storage.get(__oldCode);
  var newCode = urlParam('code'); // if (!oldCode) {
  //   sessionStorage.setItem(thirdCode, newCode)
  // }

  if (newCode === oldCode) {
    return null;
  } else {
    return newCode;
  }
}

var _window$1 = window,
    document$1 = _window$1.document,
    location = _window$1.location; // 如果重新微信授权，则调用此函数获取url
// 2.1.5增加参数：isForce
// 如果isForce 是true,则不清除token强制重新授权

var install = function install() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isForce: false
  };
  return function () {
    var overSetting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(resolve, reject) {
        var overwrittenSetting, allowWechatMiniProgram, platformType, reAuth, errorCatch, thirdType, code, isHasPToken, scope, _ref2, token, tokenType, list, authList, baseURL, _baseURL, apiUrl, iframe, tokenData, onMessage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 重写参数
                // init时候的参数是config
                // 调用login()时的参数是overSetting
                overwrittenSetting = Object.assign({
                  url: clearUrl(location.href)
                }, config, overSetting);
                allowWechatMiniProgram = !!overwrittenSetting.allowWechatMiniProgram;
                platformType = platform.getShowPlatform(allowWechatMiniProgram); // 如果不是微信的话
                // login方法将不会有实质动作

                if (!(platformType !== platform.showPlatformEnum.WECHAT)) {
                  _context.next = 6;
                  break;
                }

                resolve();
                return _context.abrupt("return");

              case 6:
                overwrittenSetting.appidAll = null;
                _context.prev = 7;
                _context.next = 10;
                return appidEnum();

              case 10:
                overwrittenSetting.appidAll = _context.sent;
                _context.next = 15;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](7);

              case 15:
                // 重新授权
                reAuth = function reAuth() {
                  var slot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

                  // 清除token
                  if (!overwrittenSetting.isForce) {
                    storage.del('token');
                    storage.del('tokenType');
                    storage.del('refreshToken');
                    storage.del('isBindMobile');

                    __debug__('Delete Cookies of getToken.reAuth');
                  }

                  slot();
                  location.replace(getWxRedirectUrl(overwrittenSetting));
                }; // 错误处理


                errorCatch = function errorCatch(statusCode) {
                  var errCodeList = {
                    23002: 'code无效',
                    10001: '参数错误',
                    10004: '字段为空',
                    20207: '获取token失败',
                    20209: '用微信注册失败'
                  }; // 如果code过期，就重新请求一次

                  if (statusCode === 23002) {
                    reAuth();
                    return;
                  } // 其他code码直接reject


                  reject({
                    statusCode: statusCode,
                    msg: errCodeList[statusCode]
                  }); // eslint-disable-line
                };

                thirdType = Number(overwrittenSetting.thirdType); // 传递了非法的thirdType直接触发reject，避免下面调用passport api
                // 导致无限刷新界面的现象

                if (overwrittenSetting.appidAll[thirdType]) {
                  _context.next = 23;
                  break;
                }

                http.log({
                  'log': JSON.stringify({
                    'name': 'sd_account_sdk',
                    'type': 'thirdType_error',
                    // 埋点统计业务方错误thidType
                    'thirdType': thirdType,
                    'domain': document$1.domain,
                    'sdk_version': packageJSON.version
                  })
                });
                alert("thirdType invalid: ".concat(thirdType)); // eslint-disable-line

                reject("thirdType invalid: ".concat(thirdType)); // eslint-disable-line

                return _context.abrupt("return");

              case 23:
                // 微信code
                // login()方法在去微信取code后还能衔接刷新页面前的逻辑的原因就是回去判断是否在url里存在code这个参数
                // 如果url里存在code这个参数，则被认为
                code = getThirdCode(); // 获取是否跳转过passport

                isHasPToken = storage.get('isHasPToken'); // 授权行为

                scope = overwrittenSetting.userThirdScope; // 获取token

                _context.next = 28;
                return tokenTimeListener(overwrittenSetting);

              case 28:
                _ref2 = _context.sent;
                token = _ref2.token;
                // 本地存储的上一次的授权行为
                tokenType = storage.get('tokenType'); // 获取同域名多公众号授权情况

                list = storage.get('authList') || JSON.stringify([]);
                authList = JSON.parse(list); // 如果当前公众号未授权，则重新授权（即使有未过期token）

                if (authList.includes(thirdType)) {
                  _context.next = 38;
                  break;
                }

                authList.push(thirdType);
                storage.set({
                  authList: JSON.stringify(authList),
                  '__currentThirdType': thirdType
                });
                reAuth();
                return _context.abrupt("return");

              case 38:
                if (!tokenType) {
                  storage.set({
                    tokenType: scope
                  });
                }

                if (!(tokenType === 'base' && scope === 'user_info' && platformType === platform.showPlatformEnum.WECHAT)) {
                  _context.next = 42;
                  break;
                }

                reAuth(function () {
                  storage.set({
                    tokenType: scope
                  });
                });
                return _context.abrupt("return");

              case 42:
                if (!(token && isHasPToken && !overwrittenSetting.isForce)) {
                  _context.next = 45;
                  break;
                }

                resolve();
                return _context.abrupt("return");

              case 45:
                // 记录走过passport
                storage.set({
                  isHasPToken: true
                }); // 如果没有走过passport

                if (!(token && !isHasPToken)) {
                  _context.next = 50;
                  break;
                }

                // const baseURL = `//passport.shuidihuzhu.com/api/account/v2/getPToken`
                // location.href = `${baseURL}?token=${decodeURIComponent(token)}`
                baseURL = '//passport.shuidihuzhu.com/api/account/v2/getPTokenV2';
                createIframe("".concat(baseURL, "?token=").concat(decodeURIComponent(token)), 'https://passport.shuidihuzhu.com', resolve);
                return _context.abrupt("return");

              case 50:
                if (!(storage.get('isBindMobile') === 'true' && token && !overwrittenSetting.isForce)) {
                  _context.next = 53;
                  break;
                }

                resolve();
                return _context.abrupt("return");

              case 53:
                if (code) {
                  _context.next = 56;
                  break;
                }

                location.replace(getWxRedirectUrl(overwrittenSetting));
                return _context.abrupt("return");

              case 56:
                // 有code没passport
                if (code) {
                  _baseURL = "https://passport.shuidihuzhu.com/api/account/v2/regWithWxV3";
                  apiUrl = "".concat(_baseURL, "?thirdCode=").concat(code, "&thirdType=").concat(overwrittenSetting.thirdType, "&userThirdScope=").concat(thirdScope[overwrittenSetting.userThirdScope], "&redirectUrl=").concat(encodeURIComponent(overwrittenSetting.url));
                  iframe = document$1.createElement('iframe');
                  iframe.style.visibility = 'hidden';

                  iframe.onload = function () {};

                  iframe.src = apiUrl;

                  onMessage = function onMessage(event) {
                    // 确认来源是passport
                    var origin = event.origin || event.originalEvent.origin;

                    if (origin === "https://passport.shuidihuzhu.com") {
                      var loginData = JSON.parse(event.data);

                      if (Number(loginData.statusCode) === 0) {
                        // window.sessionStorage.setItem(thirdCode, code)
                        // 设置token
                        tokenData = {
                          timeStamp: new Date().valueOf(),
                          token: decodeURIComponent(loginData.token),
                          refreshToken: decodeURIComponent(loginData.refreshToken),
                          cryptoUserId: decodeURIComponent(loginData.cryptoUserId),
                          isBindMobile: loginData.isBindMobile,
                          thirdType: thirdType
                        };
                        tokenData[__oldCode] = code;
                        storage.set(tokenData);

                        __debug__('Set Cookies Done getToken.regWithWxV3');

                        crossSiteCookie(tokenData, {
                          needCommonFlag: false,
                          needPayFlag: true
                        }).then(function () {
                          // 登录成功
                          resolve(loginData); // 打log

                          if (overwrittenSetting.needLog) {
                            http.log({
                              log: JSON.stringify({
                                type: 'gongyi',
                                token: decodeURIComponent(loginData.token)
                              })
                            });
                          }
                        });
                      } else {
                        errorCatch(Number(loginData.statusCode));
                      } // 注销事件，移除


                      window.removeEventListener('message', onMessage);
                      iframe.remove();
                    }
                  };

                  window.addEventListener('message', onMessage, false);
                  document$1.body.appendChild(iframe);
                }

              case 57:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 13]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};

var getToken = {
  install: install
};

var getUserInfo = (function () {
  var userThirdType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var delayPromise = createDelayPromise(1000);
  var handlePromise = new Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      var token, params;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = storage.get('token');

              if (token) {
                _context.next = 4;
                break;
              }

              resolve();
              return _context.abrupt("return");

            case 4:
              params = {
                AuthorizationV2: token
              };

              if (userThirdType) {
                params.userThirdType = userThirdType;
              } // 获取相关状态


              http.userInfo(params).then(function (res) {
                var cookie = {
                  cryptoUserId: res.data.cryptoUserId
                };

                if (res.data.headImgUrl) {
                  cookie.headImgUrl = res.data.headImgUrl;
                }

                if (res.data.nickname) {
                  cookie.nickname = res.data.nickname;
                }

                if (res.data.mobile) {
                  cookie.mobile = res.data.mobile;
                }

                if (res.data.isBindMobile) {
                  cookie.isBindMobile = res.data.isBindMobile;
                }

                if (res.data.isBindWeixin) {
                  cookie.isBindWeixin = res.data.isBindWeixin;
                }

                if (res.data.isBindWx) {
                  cookie.isBindWx = res.data.isBindWx;
                }

                var uesrInfoForStorage = JSON.parse(JSON.stringify(cookie));
                cookie.nickname = encodeURIComponent(cookie.nickname); // set cookie

                storage.set(cookie); // set localStorage

                localData.setItem('userInfo', uesrInfoForStorage); // callback data

                resolve(res.data); // sso

                crossSiteCookie(cookie);
              })["catch"](reject);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  return Promise.race([delayPromise, handlePromise]);
});

var needLogin = (function (options, code) {
  // 挂载login方法
  var login = getToken.install(options);

  var errorAction = function errorAction(code) {
    var errCode = [20205, 20102, 23001];

    if (errCode.indexOf(code) > -1) {
      storage.del('isBindMobile');
      storage.del('token');
      storage.del('refreshToken');

      __debug__('Delete Cookies of needLogin');

      setTimeout(function () {
        login();
      }, 500);
    }
  };

  errorAction(code);
});

var bizType$1 = {
  // 水滴互助
  shuidihuzhu: 'SDHZ',
  // 水滴筹
  shuidichou: 'SDCF',
  // 水滴保
  sdbao: 'SDB',
  // 水滴公益沿用水滴筹域名的bizType
  shuidigongyi: 'SDCF'
};
var domainArr = window.document.domain.split('.');
var biz = bizType$1[domainArr[domainArr.length - 2]];

var install$1 = function install(options) {
  return function (config) {
    return new Promise(function (resolve, reject) {
      var overwrittenSetting = Object.assign({}, options, config);
      var allowWechatMiniProgram = !!overwrittenSetting.allowWechatMiniProgram; // 微信内外走不同接口
      // 如果在微信内想要走注册逻辑 需要在config中isForceRegist设置为true

      if (platform.getShowPlatform(allowWechatMiniProgram) === platform.showPlatformEnum.WECHAT && !overwrittenSetting.isForceRegist) {
        // in wechat
        http.bindMobile({
          mobile: config.mobile,
          verifyCode: config.verifyCode,
          platform: 1,
          thirdType: overwrittenSetting.thirdType,
          bizType: biz,
          AuthorizationV2: storage.get('token')
        }).then(function (res) {
          // 写入cookie
          var tokenData = {
            isBindMobile: true,
            token: res.data.sdToken,
            refreshToken: res.data.refreshToken,
            cryptoUserId: res.data.cryptoUserId
          }; // 写入cookie

          storage.set(tokenData); // sso

          var crossData = {
            isBindMobile: true,
            mobile: res.data.mobile
          };
          var _config$needCommonFla = config.needCommonFlag,
              needCommonFlag = _config$needCommonFla === void 0 ? true : _config$needCommonFla,
              _config$needPayFlag = config.needPayFlag,
              needPayFlag = _config$needPayFlag === void 0 ? true : _config$needPayFlag;
          if (needCommonFlag) crossSiteCookie(crossData, {
            needCommonFlag: needCommonFlag,
            needPayFlag: false
          });
          if (needPayFlag) crossSiteCookie(tokenData, {
            needCommonFlag: false,
            needPayFlag: needPayFlag
          });
          resolve(tokenData);
        })["catch"](function (err) {
          // 处理常规错误
          needLogin(options, err.code);
          reject(err);
        });
      } else {
        // 其他平台就走注册
        http.registAccountWithMobile({
          mobile: config.mobile,
          verifyCode: config.verifyCode,
          thirdType: overwrittenSetting.thirdType,
          bizType: biz,
          platform: platform.getShowPlatform(allowWechatMiniProgram),
          channel: urlParam('channel')
        }).then(function (res) {
          var tokenData = {
            isBindMobile: true,
            token: res.data.sdToken,
            refreshToken: res.data.refreshToken,
            cryptoUserId: res.data.cryptoUserId,
            mobile: res.data.mobile,
            timeStamp: new Date().valueOf()
          };

          if (res.data.headImgUrl) {
            tokenData.headImgUrl = res.data.headImgUrl;
          }

          if (res.data.nickname) {
            tokenData.nickname = encodeURIComponent(res.data.nickname);
          }

          storage.set(tokenData); // 微信内只sso收银台，微信外执行收银台和业务sso

          var corssSiteCookieOpts = {
            needPayFlag: true
          };
          if (platform.getShowPlatform(allowWechatMiniProgram) === platform.showPlatformEnum.WECHAT) corssSiteCookieOpts.needCommonFlag = false;
          crossSiteCookie(tokenData, corssSiteCookieOpts).then(function () {
            resolve(res);
          });
        })["catch"](function (err) {
          // 处理常规错误
          needLogin(options, err.code);
          reject(err);
        });
      }
    });
  };
};

var loginWithMobile = {
  install: install$1
};

var interceptHttpCode = {
  install: function install(config) {
    var login = getToken.install(config);
    var flashLock = false;

    function delTokenAndFlash(code) {
      try {
        storage.del('refreshToken');
        storage.del('isBindMobile');
        storage.del('token');
        storage.del('tokenType');
        storage.del('mobile');

        __debug__('Delete Cookies of interceptHttpCode.delTokenAndFlash.' + code);
      } catch (e) {}

      setTimeout(function () {
        platform.getShowPlatform() === platform.showPlatformEnum.WECHAT ? login() : maxCountReloadPage();
      }, 500);
    }

    var codeLib = {
      20205: function _() {
        if (flashLock) {
          return;
        }

        flashLock = true;
        http.refreshToken({
          token: storage.get('token'),
          refreshToken: storage.get('refreshToken')
        }).then(function (res) {
          flashLock = false;
          var data = {
            token: res.data.sdToken,
            refreshToken: res.data.refreshToken,
            isBindMobile: res.data.bindMobile,
            mobile: res.data.mobile,
            timeStamp: new Date().valueOf()
          };
          storage.set(data); // 微信内只sso收银台，微信外执行收银台和业务sso

          var crossSiteCookieOpts = {
            needPayFlag: true
          };
          if (platform.getShowPlatform() === platform.showPlatformEnum.WECHAT) crossSiteCookieOpts.needCommonFlag = false;
          crossSiteCookie(data, crossSiteCookieOpts).then(function () {
            setTimeout(function () {
              reloadPage();
            }, 500);
          });
        })["catch"](function () {
          flashLock = false;
          storage.del('isBindMobile');
          storage.del('token');
          storage.del('refreshToken');

          __debug__('Delete Cookies of interceptHttpCode.20205.catch');

          setTimeout(function () {
            platform.getShowPlatform() === platform.showPlatformEnum.WECHAT ? login() : reloadPage();
          }, 500);
        });
      },
      20203: function _() {
        delTokenAndFlash(20203);
      },
      20102: function _() {
        delTokenAndFlash(20102);
      },
      23001: function _() {
        delTokenAndFlash(23001);
      }
    };
    var codeAction = Object.assign({}, codeLib, config.extend);
    return function (code) {
      if (!code) {
        return false;
      }

      http.log({
        log: JSON.stringify({
          code: code,
          token: storage.get('token')
        })
      });

      try {
        codeAction[code]();
      } catch (e) {// console.warn(e)
      }
    };
  }
};

/* eslint-disable */
function captchaLib () {
  var initGeetest;

  (function (window) {

    if (typeof window === 'undefined') {
      throw new Error('Geetest requires browser environment');
    }

    var document = window.document;
    var Math = window.Math;
    var head = document.getElementsByTagName("head")[0];

    function _Object(obj) {
      this._obj = obj;
    }

    _Object.prototype = {
      _each: function _each(process) {
        var _obj = this._obj;

        for (var k in _obj) {
          if (_obj.hasOwnProperty(k)) {
            process(k, _obj[k]);
          }
        }

        return this;
      }
    };

    function Config(config) {
      var self = this;

      new _Object(config)._each(function (key, value) {
        self[key] = value;
      });
    }

    Config.prototype = {
      api_server: 'api.geetest.com',
      protocol: 'http://',
      typePath: '/gettype.php',
      fallback_config: {
        slide: {
          static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
          type: 'slide',
          slide: '/static/js/geetest.0.0.0.js'
        },
        fullpage: {
          static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
          type: 'fullpage',
          fullpage: '/static/js/fullpage.0.0.0.js'
        }
      },
      _get_fallback_config: function _get_fallback_config() {
        var self = this;

        if (isString(self.type)) {
          return self.fallback_config[self.type];
        } else if (self.new_captcha) {
          return self.fallback_config.fullpage;
        } else {
          return self.fallback_config.slide;
        }
      },
      _extend: function _extend(obj) {
        var self = this;

        new _Object(obj)._each(function (key, value) {
          self[key] = value;
        });
      }
    };

    var isNumber = function isNumber(value) {
      return typeof value === 'number';
    };

    var isString = function isString(value) {
      return typeof value === 'string';
    };

    var isBoolean = function isBoolean(value) {
      return typeof value === 'boolean';
    };

    var isObject = function isObject(value) {
      return _typeof(value) === 'object' && value !== null;
    };

    var isFunction = function isFunction(value) {
      return typeof value === 'function';
    };

    var callbacks = {};
    var status = {};

    var random = function random() {
      return parseInt(Math.random() * 10000) + new Date().valueOf();
    };

    var loadScript = function loadScript(url, cb) {
      var script = document.createElement("script");
      script.charset = "UTF-8";
      script.async = true;

      script.onerror = function () {
        cb(true);
      };

      var loaded = false;

      script.onload = script.onreadystatechange = function () {
        if (!loaded && (!script.readyState || "loaded" === script.readyState || "complete" === script.readyState)) {
          loaded = true;
          setTimeout(function () {
            cb(false);
          }, 0);
        }
      };

      script.src = url;
      head.appendChild(script);
    };

    var normalizeDomain = function normalizeDomain(domain) {
      // special domain: uems.sysu.edu.cn/jwxt/geetest/
      // return domain.replace(/^https?:\/\/|\/.*$/g, ''); uems.sysu.edu.cn
      return domain.replace(/^https?:\/\/|\/$/g, ''); // uems.sysu.edu.cn/jwxt/geetest
    };

    var normalizePath = function normalizePath(path) {
      path = path.replace(/\/+/g, '/');

      if (path.indexOf('/') !== 0) {
        path = '/' + path;
      }

      return path;
    };

    var normalizeQuery = function normalizeQuery(query) {
      console.log("");

      if (!query) {
        return '';
      }

      var q = '?';

      new _Object(query)._each(function (key, value) {
        if (isString(value) || isNumber(value) || isBoolean(value)) {
          q = q + encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
        }
      });

      if (q === '?') {
        q = '';
      }

      return q.replace(/&$/, '');
    };

    var makeURL = function makeURL(protocol, domain, path, query) {
      domain = normalizeDomain(domain);
      var url = normalizePath(path) + normalizeQuery(query);

      if (domain) {
        url = protocol + domain + url;
      }

      return url;
    };

    var load = function load(protocol, domains, path, query, cb) {
      var tryRequest = function tryRequest(at) {
        var url = makeURL(protocol, domains[at], path, query);
        loadScript(url, function (err) {
          if (err) {
            if (at >= domains.length - 1) {
              cb(true);
            } else {
              tryRequest(at + 1);
            }
          } else {
            cb(false);
          }
        });
      };

      tryRequest(0);
    };

    var jsonp = function jsonp(domains, path, config, callback) {
      if (isObject(config.getLib)) {
        config._extend(config.getLib);

        callback(config);
        return;
      }

      if (config.offline) {
        callback(config._get_fallback_config());
        return;
      }

      var cb = "geetest_" + random();

      window[cb] = function (data) {
        if (data.status == 'success') {
          callback(data.data);
        } else if (!data.status) {
          callback(data);
        } else {
          callback(config._get_fallback_config());
        }

        window[cb] = undefined;

        try {
          delete window[cb];
        } catch (e) {}
      };

      load(config.protocol, domains, path, {
        gt: config.gt,
        callback: cb
      }, function (err) {
        if (err) {
          callback(config._get_fallback_config());
        }
      });
    };

    var throwError = function throwError(errorType, config) {
      var errors = {
        networkError: '网络错误',
        gtTypeError: 'gt字段不是字符串类型'
      };

      if (typeof config.onError === 'function') {
        config.onError(errors[errorType]);
      } else {
        throw new Error(errors[errorType]);
      }
    };

    var detect = function detect() {
      return window.Geetest || document.getElementById("gt_lib");
    };

    if (detect()) {
      status.slide = "loaded";
    }

    initGeetest = function initGeetest(userConfig, callback) {
      var config = new Config(userConfig);

      if (userConfig.https) {
        config.protocol = 'https://';
      } else if (!userConfig.protocol) {
        config.protocol = window.location.protocol + '//';
      }

      if (isObject(userConfig.getType)) {
        config._extend(userConfig.getType);
      }

      jsonp([config.api_server || config.apiserver], config.typePath, config, function (newConfig) {
        var type = newConfig.type;

        var init = function init() {
          config._extend(newConfig);

          callback(new window.Geetest(config));
        };

        callbacks[type] = callbacks[type] || [];
        var s = status[type] || 'init';

        if (s === 'init') {
          status[type] = 'loading';
          callbacks[type].push(init);
          load(config.protocol, newConfig.static_servers || newConfig.domains, newConfig[type] || newConfig.path, null, function (err) {
            if (err) {
              status[type] = 'fail';
              throwError('networkError', config);
            } else {
              status[type] = 'loaded';
              var cbs = callbacks[type];

              for (var i = 0, len = cbs.length; i < len; i = i + 1) {
                var cb = cbs[i];

                if (isFunction(cb)) {
                  cb();
                }
              }

              callbacks[type] = [];
            }
          });
        } else if (s === "loaded") {
          init();
        } else if (s === "fail") {
          throwError('networkError', config);
        } else if (s === "loading") {
          callbacks[type].push(init);
        }
      });
    };
  })(window);

  return initGeetest;
}

var initGeetest = captchaLib();
var captcha = (function (config) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  // callback返回一个object
  // 0代表成功
  // 1代表失败
  // 2代表图形验证加载出了问题
  // 获取初始化需要的数据
  http.initCaptcha({
    AuthorizationV2: storage.get('token'),
    cryptoMobile: config.cryptoMobile,
    clientType: 'h5'
  }).then(function (res) {
    // 初始化图形验证js以及接口
    initGeetest({
      gt: res.gt,
      // 'fd7df371d6222a2a5b654757abca5412'
      challenge: res.challenge,
      offline: !res.success,
      new_captcha: true,
      width: '100%',
      product: 'bind'
    }, function (captchaObj) {
      // 渲染dom 图形验证
      // captchaObj.appendTo(config.domPosition || '#captcha')
      // 监听初始化结果
      captchaObj.onReady(function () {
        captchaObj.verify();
      }); // 客户端认证成功

      captchaObj.onSuccess(function () {
        // 获取结果
        var result = captchaObj.getValidate(); // 客户端认证结果返给后端

        http.checkCaptcha({
          AuthorizationV2: storage.get('token'),
          cryptoMobile: config.cryptoMobile,
          clientType: 'h5',
          geetest_challenge: result.geetest_challenge,
          geetest_validate: result.geetest_validate,
          geetest_seccode: result.geetest_seccode,
          bizType: config.bizType
        }).then(function (response) {
          // 服务端认证成功
          callback(response); // 清理掉图形验证码

          document.querySelector(config.domPosition || '#captcha').innerHTML = '';
        })["catch"](function (err) {
          // 服务端认证失败
          callback(err); // 重置验证

          if (err.code === 200002) {
            captchaObj.reset();
          }
        });
      }); // 客户端认证失败

      captchaObj.onError(function () {
        /* eslint-disable standard/no-callback-literal */
        callback({
          code: 1,
          msg: '客户端校验失败'
        }); // 重置验证

        captchaObj.reset();
      }); // 用户关闭

      captchaObj.onClose(function () {
        callback({
          code: 1,
          msg: '请通过验证'
        }); // 重置验证

        captchaObj.reset();
      });
    });
  })["catch"](function () {
    // 图形认证加载出问题
    callback({
      code: 2,
      msg: '图形验证初始化失败'
    });
  });
});

var install$2 = function install() {
  return function (config) {
    return new Promise(function (resolve, reject) {
      http.sendVerifyCode({
        mobile: config.mobile,
        bizType: config.bizType
      }).then(function (res) {
        resolve(res);
      })["catch"](function (err) {
        // 风险账户走图形验证，正常报错走reject
        if (Number(err.code) === 200001) {
          captcha({
            cryptoMobile: err.data.cryptoMobile,
            bizType: config.bizType,
            domPosition: config.domPosition
          }, function (response) {
            // 认证通过，递归本方法
            if (response.code === 0) {
              resolve(response);
              return;
            } // 认证不通过，重置图形验证，并reject


            reject(response);
          });
          return;
        }

        reject(err);
      });
    });
  };
};

var sendVerifyCode = {
  install: install$2
};

var install$3 = function install() {
  return function (config) {
    return new Promise(function (resolve, reject) {
      var token = storage.get('token');

      if (!token) {
        resolve();
        return;
      }

      http.sendVerifyCodeWithToken({
        mobile: config.mobile,
        bizType: config.bizType,
        AuthorizationV2: token
      }).then(function (res) {
        resolve(res);
      })["catch"](function (err) {
        // 风险账户走图形验证，正常报错走reject
        if (Number(err.code) === 200001) {
          captcha({
            cryptoMobile: err.data.cryptoMobile,
            bizType: config.bizType,
            domPosition: config.domPosition
          }, function (response) {
            // 认证通过，递归本方法
            if (response.code === 0) {
              resolve(response);
              return;
            } // 认证不通过，重置图形验证，并reject


            reject(response);
          });
          return;
        }

        reject(err);
      });
    });
  };
};

var sendVerifyCodeWithToken = {
  install: install$3
};

var install$4 = function install() {
  return function (config) {
    return new Promise(function (resolve, reject) {
      var token = storage.get('token');

      if (!token) {
        resolve();
        return;
      }

      http.checkVerifyCodeWithToken({
        mobile: config.mobile,
        verifyCode: config.verifyCode,
        AuthorizationV2: token
      }).then(function (res) {
        resolve(res);
      })["catch"](function (err) {
        reject(err);
      });
    });
  };
};

var checkVerifyCodeWithToken = {
  install: install$4
};

// 方案折中

tokenTimeListener();
var getTokenInCookie = (function () {
  return storage.get('token');
});

function main$1(mobile, verifyCode) {
  var needCommonFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var needPayFlag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var platform$1 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var win = window;
  var doc = win.document;
  var domainArr = doc.domain.split('.');
  var biz = bizType[domainArr[domainArr.length - 2]];
  return new Promise(function (resolve, reject) {
    http.bindMobile({
      mobile: mobile,
      verifyCode: verifyCode,
      platform: platform$1,
      bizType: biz,
      AuthorizationV2: storage.get('token')
    }).then(function (res) {
      var tokenData = {
        isBindMobile: true,
        token: res.data.sdToken,
        refreshToken: res.data.refreshToken,
        cryptoUserId: res.data.cryptoUserId
      };
      storage.set(tokenData);
      var userInfoInStorage = localData.getItem('userInfo');

      if (userInfoInStorage) {
        localData.setItem('userInfo', _objectSpread2({}, userInfoInStorage, {
          mobile: mobile
        }));
      } // sso


      var crossData = {
        isBindMobile: true,
        mobile: res.data.mobile
      };

      if (platform.getShowPlatform() === platform.showPlatformEnum.WECHAT) {
        if (needCommonFlag) crossSiteCookie(crossData, {
          needCommonFlag: needCommonFlag,
          needPayFlag: false
        });
        if (needPayFlag) crossSiteCookie(tokenData, {
          needCommonFlag: false,
          needPayFlag: needPayFlag
        });
      } else {
        crossSiteCookie(tokenData, {
          needCommonFlag: needCommonFlag,
          needPayFlag: needPayFlag
        });
      }

      return resolve(res);
    })["catch"](reject);
  });
}

var install$5 = function install() {
  return function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (resolve, reject) {
      http.loginByLongCode({
        mobile: config.mobile,
        code: config.code,
        userThirdType: config.thirdType
      }).then(function (res) {
        var tokenData = {
          isBindMobile: res.data.bindMobile,
          token: res.data.sdToken,
          refreshToken: res.data.refreshToken,
          cryptoUserId: res.data.cryptoUserId,
          mobile: res.data.mobile,
          timeStamp: new Date().valueOf()
        };

        if (res.data.headImgUrl) {
          tokenData.headImgUrl = res.data.headImgUrl;
        }

        if (res.data.nickname) {
          tokenData.nickname = encodeURIComponent(res.data.nickname);
        }

        storage.set(tokenData); // 单点登录

        var corssSiteCookieOpts = {
          needPayFlag: true
        };
        crossSiteCookie(tokenData, corssSiteCookieOpts).then(function () {
          resolve(res);
        });
      })["catch"](function (err) {
        reject(err);
      });
    });
  };
};

var loginWithLongCode = {
  install: install$5
};

function changeBind () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mobile = options.mobile,
        verifyCode = options.verifyCode,
        thirdType = options.thirdType;
    return new Promise(function (resolve, reject) {
      http.changeBind({
        mobile: mobile,
        verifyCode: verifyCode,
        thirdType: thirdType || config.thirdType,
        AuthorizationV2: storage.get('token')
      }).then(function (res) {
        // 换绑成功后更新本地的手机号信息
        if (res.code === 0) {
          var userInfoInStorage = localData.getItem('userInfo');

          if (userInfoInStorage) {
            localData.setItem('userInfo', _objectSpread2({}, userInfoInStorage, {
              mobile: mobile
            }));
          }
        }

        return resolve(res);
      })["catch"](reject);
    });
  };
}

function isLoginSync() {
  console.warn('此同步接口存在前后端数据不同步问题，请使用新版isLoginAsync 异步接口');
  var token = storage.get('token');

  if (!token) {
    // token不存在，未登录
    return false;
  }

  var now = new Date().valueOf();
  var timeStamp = storage.get('timeStamp');
  var expired = now - Number(timeStamp) > 1000 * 3600 * 24 * 6;

  if (timeStamp && !expired) {
    return true;
  } else {
    return false;
  }
}

var getOneClickLoginInfo = (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var clientType = options.clientType;
  return new Promise(function (resolve, reject) {
    http.getSeqNum({
      clientType: clientType
    }).then(function (res) {
      var _res$data = res.data,
          url = _res$data.url,
          seqNum = _res$data.seqNum;
      var img = new Image(); // eslint-disable-line

      img.onload = function () {
        // 取号成功后获取手机号
        http.getMobile({
          seqNum: seqNum
        }).then(function (res) {
          var mobile = res.data;
          resolve({
            seqNum: seqNum,
            mobile: mobile
          });
        })["catch"](reject);
      };

      img.onerror = function () {
        reject(); // eslint-disable-line
      };

      img.src = url;
    })["catch"](reject);
  });
});

function oneClickLogin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var overwrittenSetting = Object.assign({}, options, config);
    var allowWechatMiniProgram = !!overwrittenSetting.allowWechatMiniProgram;
    var seqNum = overwrittenSetting.seqNum,
        param = overwrittenSetting.param,
        thirdType = overwrittenSetting.thirdType;
    return new Promise(function (resolve, reject) {
      http.oneClickLogin({
        seqNum: seqNum,
        param: param,
        thirdType: thirdType,
        AuthorizationV2: storage.get('token')
      }).then(function (res) {
        var tokenData = {
          isBindMobile: true,
          token: res.data.sdToken,
          refreshToken: res.data.refreshToken,
          cryptoUserId: res.data.cryptoUserId,
          mobile: res.data.mobile,
          timeStamp: new Date().valueOf()
        };

        if (res.data.headImgUrl) {
          tokenData.headImgUrl = res.data.headImgUrl;
        }

        if (res.data.nickname) {
          tokenData.nickname = encodeURIComponent(res.data.nickname);
        }

        storage.set(tokenData); // 微信内只sso收银台，微信外执行收银台和业务sso

        var corssSiteCookieOpts = {
          needPayFlag: true
        };
        if (platform.getShowPlatform(allowWechatMiniProgram) === platform.showPlatformEnum.WECHAT) corssSiteCookieOpts.needCommonFlag = false;
        crossSiteCookie(tokenData, corssSiteCookieOpts).then(function () {
          resolve(res);
        });
      })["catch"](reject);
    });
  };
}

function logout() {
  storage.del('token');
  storage.del('tokenType');
  storage.del('refreshToken');

  __debug__('Delete Cookies of logout');
}

function getAuthList() {
  var list = storage.get('authList') || JSON.stringify([]);
  return JSON.parse(list);
}

var eventBus = function eventBus() {
  this.events = {};
};

eventBus.prototype.on = function (eventName, fn) {
  if (typeof fn !== 'function') throw new Error('fn is not function');
  if (!eventName) throw new Error('eventName is not null');
  if (!this.events.hasOwnProperty(eventName)) this.events[eventName] = [];
  this.events[eventName].push(fn);
};

eventBus.prototype.emit = function (eventName, data) {
  if (!eventName) throw new Error('eventName is not null');
  if (this.events.hasOwnProperty(eventName)) this.events[eventName].map(function (fn) {
    return fn(data);
  });
};

eventBus.prototype.off = function (eventName) {
  if (!eventName) throw new Error('eventName is not null');
  if (this.events.hasOwnProperty(eventName)) delete this.events[eventName];
};

var configure;
var eventBus$1 = new eventBus();
var msgType = '_sd_config'; // 初始化 config

var install$6 = function install() {
  var cacheConfig = localData.getItemByTime(msgType);

  if (cacheConfig) {
    // 获取缓存配置，有效期15分钟。
    configure = cacheConfig;
    http.log({
      'log': JSON.stringify({
        'name': 'sd_account_sdk',
        'type': 'use_gee_cache',
        // 埋点统计获取缓存配置
        'sdk_version': packageJSON.version
      })
    });
    return;
  }

  http.getGeeConfig({
    sdKey: sdKey
  }).then(function (res) {
    configure = res.data;
    eventBus$1.emit(msgType, true);
    localData.setItemByTime(msgType, configure); // 缓存

    http.log({
      'log': JSON.stringify({
        'name': 'sd_account_sdk',
        'type': 'use_gee_config',
        // 埋点统计获取新配置
        'sdk_version': packageJSON.version
      })
    });
  })["catch"](function (e) {
    eventBus$1.emit(msgType, false);
    console.log("initialize error: ".concat(e.msg || e.message()));
  });
};

/* eslint prefer-promise-reject-errors: ["error", {"allowEmptyReject": true}] */

var defaultConfig = function defaultConfig() {
  return new Promise(function (resolve, reject) {
    if (configure) {
      resolve(configure);
    } else {
      eventBus$1.on(msgType, function (status) {
        if (status) {
          resolve(configure);
        } else {
          reject();
        }
      });
      setTimeout(function () {
        return reject();
      }, 5000);
    }
  });
};

var doOnePassLogin = (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var delayPromise = createDelayPromise(5500);
    var handlePromise = new Promise(
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(resolve, reject) {
        var overwrittenSetting, allowWechatMiniProgram, mobile, timeout, channel, category, bindMobileOnly, thirdType, feedback, geetestConfs, geetestConf, opInstance;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                overwrittenSetting = Object.assign({}, options, config);
                allowWechatMiniProgram = !!overwrittenSetting.allowWechatMiniProgram;
                mobile = overwrittenSetting.mobile, timeout = overwrittenSetting.timeout, channel = overwrittenSetting.channel, category = overwrittenSetting.category, bindMobileOnly = overwrittenSetting.bindMobileOnly, thirdType = overwrittenSetting.thirdType;
                feedback = {
                  data: '',
                  mobile: mobile
                };
                _context2.prev = 4;
                _context2.next = 7;
                return defaultConfig();

              case 7:
                geetestConfs = _context2.sent;
                _context2.next = 12;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);

              case 12:
                if (!(!mobile || !geetestConfs)) {
                  _context2.next = 19;
                  break;
                }

                feedback.code = 10001;
                feedback.msg = '参数错误';
                reject(feedback);
                return _context2.abrupt("return");

              case 19:
                mobile += '';

              case 20:
                geetestConf = geetestConfs[category || channel] || {};
                opInstance = new GOP({
                  app_id: geetestConf.appId,
                  timeout: timeout || 3000
                });

                if (isWiFiUserOfBD()) {
                  feedback.code = 20902;
                  feedback.msg = '当前网络不支持一键登录';
                  reject(feedback);
                } else {
                  opInstance.onGatewaySuccess(
                  /*#__PURE__*/
                  function () {
                    var _ref2 = _asyncToGenerator(
                    /*#__PURE__*/
                    regeneratorRuntime.mark(function _callee(data) {
                      var processId, accesscode, queryData, fields, i, k, isBindMobileRes, win, doc, domainArr, biz;
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              processId = data.process_id, accesscode = data.accesscode;
                              queryData = {
                                processId: processId,
                                channel: channel,
                                mobile: mobile,
                                accesscode: accesscode,
                                category: category,
                                sdKey: sdKey
                              };
                              fields = ['platform', 'bizType', 'thirdType'];

                              for (i in fields) {
                                k = fields[i];

                                if (geetestConf[k]) {
                                  queryData[k] = geetestConf[k];
                                }
                              } // 微信内&登录&未绑定手机号状态下使用绑定手机号功能


                              isBindMobileRes = null;
                              win = window;
                              doc = win.document;
                              domainArr = doc.domain.split('.');
                              biz = bizType[domainArr[domainArr.length - 2]];
                              _context.prev = 9;
                              _context.next = 12;
                              return http.isBindMobileAsync({}, {
                                AuthorizationV2: storage.get('token')
                              });

                            case 12:
                              isBindMobileRes = _context.sent;
                              _context.next = 17;
                              break;

                            case 15:
                              _context.prev = 15;
                              _context.t0 = _context["catch"](9);

                            case 17:
                              if (!(isBindMobileRes != null && platform.getShowPlatform(allowWechatMiniProgram) === platform.showPlatformEnum.WECHAT && isBindMobileRes.code === 0 && isBindMobileRes.data === false)) {
                                _context.next = 21;
                                break;
                              }

                              http.bindMobileWithGee({
                                mobile: mobile,
                                processId: processId,
                                accesscode: accesscode,
                                thirdType: thirdType,
                                bizType: biz,
                                channel: channel,
                                platform: platform.getShowPlatform(),
                                category: category,
                                AuthorizationV2: storage.get('token'),
                                sdKey: sdKey
                              }).then(function (resp) {
                                var tokenData = {
                                  isBindMobile: true,
                                  token: resp.data.sdToken,
                                  cryptoUserId: resp.data.cryptoUserId,
                                  mobile: resp.data.mobile,
                                  timeStamp: new Date().valueOf()
                                };

                                if (resp.data.headImgUrl) {
                                  tokenData.headImgUrl = resp.data.headImgUrl;
                                }

                                if (resp.data.nickname) {
                                  tokenData.nickname = encodeURIComponent(resp.data.nickname);
                                }

                                storage.set(tokenData); // Do the auth actions.

                                var corssSiteCookieOpts = {
                                  needPayFlag: true,
                                  needCommonFlag: false
                                };
                                crossSiteCookie(tokenData, corssSiteCookieOpts).then(function () {
                                  resolve();
                                });
                              })["catch"](function (err) {
                                reject(err);
                              });
                              _context.next = 25;
                              break;

                            case 21:
                              if (!(bindMobileOnly === true)) {
                                _context.next = 24;
                                break;
                              }

                              resolve();
                              return _context.abrupt("return");

                            case 24:
                              http.doOnePassLogin(queryData).then(function (resp) {
                                if (resp.code !== 0) {
                                  reject(resp);
                                } else {
                                  var tokenData = {
                                    isBindMobile: true,
                                    token: resp.data.sdToken,
                                    cryptoUserId: resp.data.cryptoUserId,
                                    mobile: resp.data.mobile,
                                    timeStamp: new Date().valueOf()
                                  };

                                  if (resp.data.headImgUrl) {
                                    tokenData.headImgUrl = resp.data.headImgUrl;
                                  }

                                  if (resp.data.nickname) {
                                    tokenData.nickname = encodeURIComponent(resp.data.nickname);
                                  }

                                  storage.set(tokenData); // Do the auth actions.

                                  var corssSiteCookieOpts = {
                                    needPayFlag: true
                                  };

                                  if (platform.getShowPlatform(allowWechatMiniProgram) === platform.showPlatformEnum.WECHAT) {
                                    corssSiteCookieOpts.needCommonFlag = false;
                                  }

                                  crossSiteCookie(tokenData, corssSiteCookieOpts).then(function () {
                                    resolve(resp);
                                  });
                                  http.log({
                                    'log': JSON.stringify({
                                      'name': 'sd_account_sdk',
                                      'type': 'onepasslogin_success',
                                      'biztype': biz,
                                      'thirdtype': overwrittenSetting.thirdType,
                                      'channel': channel,
                                      'platform': platform.getShowPlatform(),
                                      'category': category,
                                      'sdk_version': packageJSON.version
                                    })
                                  });
                                }
                              })["catch"](function (err) {
                                reject(err);
                                http.log({
                                  'log': JSON.stringify({
                                    'name': 'sd_account_sdk',
                                    'type': 'onepasslogin_fail',
                                    'biztype': biz,
                                    'thirdtype': overwrittenSetting.thirdType,
                                    'channel': channel,
                                    'platform': platform.getShowPlatform(),
                                    'category': category,
                                    'sdk_version': packageJSON.version
                                  })
                                });
                              });

                            case 25:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[9, 15]]);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }()).onGatewayFail(function (e) {
                    feedback.code = 20901;
                    feedback.msg = "\u6781\u9A8C\u4E0D\u652F\u6301\u4E00\u952E\u767B\u5F55\uFF0C\u9519\u8BEF\u7801 : ".concat(e.code);
                    reject(feedback);
                  }); // Do action .

                  opInstance.gateway({
                    phone: mobile
                  });
                }

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 10]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    return Promise.race([delayPromise, handlePromise]);
  };
});

var install$7 = function install(options) {
  return function (config) {
    return new Promise(function (resolve, reject) {
      var overwrittenSetting = Object.assign({}, options, config);
      var allowWechatMiniProgram = !!overwrittenSetting.allowWechatMiniProgram;
      var mobile = overwrittenSetting.mobile,
          code = overwrittenSetting.code,
          thirdtype = overwrittenSetting.thirdType,
          biztype = overwrittenSetting.bizType,
          channel = overwrittenSetting.channel;
      http.smsPNDirectLogin({
        mobile: mobile,
        code: code,
        thirdtype: thirdtype,
        biztype: biztype,
        channel: channel,
        platform: platform.getShowPlatform(allowWechatMiniProgram)
      }).then(function (res) {
        var _res$data = res.data,
            token = _res$data.sdToken,
            refreshToken = _res$data.refreshToken,
            cryptoUserId = _res$data.cryptoUserId,
            mobile = _res$data.mobile,
            headImgUrl = _res$data.headImgUrl,
            nickname = _res$data.nickname;
        var tokenData = {
          token: token,
          refreshToken: refreshToken,
          cryptoUserId: cryptoUserId,
          mobile: mobile,
          isBindMobile: true,
          timeStamp: new Date().valueOf()
        };

        if (headImgUrl) {
          tokenData.headImgUrl = headImgUrl;
        }

        if (nickname) {
          tokenData.nickname = encodeURIComponent(nickname);
        }

        storage.set(tokenData); // 微信内只sso收银台，微信外执行收银台和业务sso

        var corssSiteCookieOpts = {
          needPayFlag: true
        };
        if (platform.getShowPlatform(allowWechatMiniProgram) === platform.showPlatformEnum.WECHAT) corssSiteCookieOpts.needCommonFlag = false;
        crossSiteCookie(tokenData, corssSiteCookieOpts).then(function () {
          resolve(res);
        });
      })["catch"](reject);
    });
  };
};

var smsPNDirectLogin = {
  install: install$7
};

var install$8 = function install(options) {
  return function (config) {
    return new Promise(
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(resolve, reject) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = resolve;
                _context.next = 4;
                return defaultConfig();

              case 4:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t2 = _context["catch"](0);
                reject(_context.t2);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};

var getDefault = {
  install: install$8
};

var install$9 = function install() {
  return function (config) {
    return new Promise(function (resolve, reject) {
      http.isLoginAsync({
        AuthorizationV2: storage.get('token')
      }).then(function (res) {
        resolve(res.data);
      })["catch"](function () {
        // reject(err)
        resolve(false); // code码不为0 默认全部为未登录
      });
    });
  };
};

var isLoginAsync = {
  install: install$9
};

var install$a = function install() {
  return function (config) {
    return new Promise(function (resolve, reject) {
      http.isBindMobileAsync({
        AuthorizationV2: storage.get('token')
      }).then(function (res) {
        resolve(res.data);
      })["catch"](function (err) {
        reject(err);
      });
    });
  };
};

var isBindMobileAsync = {
  install: install$a
};

var account = function account(config) {
  install$6();
  setCrossCookieKey(config.crossCookieKey);
  setSSOWaitTime(config.ssoWaitTime);
  config.baseUrl && setBaseUrl(config.baseUrl);
  persistDebugFunc(config);
  return {
    // 通过极验进行运营商验证的一键登录
    doOnePassLogin: doOnePassLogin(config),
    // 绑定手机号
    bindMobile: main$1,
    // login挂载
    login: getToken.install(config),
    // 微信外登录
    loginOutWx: tokenTimeListener,
    // 是否登录（只判断是否存在token）
    isLogin: function isLogin() {
      console.warn('此同步接口存在前后端数据不同步问题，请使用新版isLoginAsync 异步接口');
      return !!storage.get('token');
    },
    // 是否绑定手机
    isBindMobileAction: function isBindMobileAction() {
      console.warn('此同步接口存在前后端数据不同步问题，请使用新版isBindMobileAsync异步接口');
      return storage.get('isBindMobile') === 'true';
    },
    // 获取cookie里的token
    getToken: getTokenInCookie,
    // 获取用户信息
    getUserInfo: getUserInfo,
    // 获取userid
    getUserId: function getUserId() {
      return storage.get('cryptoUserId');
    },
    // 验证码
    sendVerifyCode: sendVerifyCode.install(config),
    // 验证码 脱敏
    sendVerifyCodeWithToken: sendVerifyCodeWithToken.install(config),
    // 检验验证码
    checkVerifyCodeWithToken: checkVerifyCodeWithToken.install(config),
    // 非微信登录
    loginWithMobile: loginWithMobile.install(config),
    // 登录相关错误code拦截
    interceptHttpCode: interceptHttpCode.install(config),
    // 使用手机号+code（账号系统生成）登录
    loginWithLongCode: loginWithLongCode.install(config),
    // 换绑手机号
    changeBind: changeBind(config),
    // 同步判断用户是否登录（判断token和过期时间）
    isLoginSync: isLoginSync,
    // 手机号一键登录: 获取一键登录的标识信息
    getOneClickLoginInfo: getOneClickLoginInfo,
    // 手机号一键登录: 注册
    oneClickLogin: oneClickLogin(config),
    // 短信点击来源手机号免验证码登录
    smsPNDirectLogin: smsPNDirectLogin.install(config),
    // 登出
    logout: logout,
    // 获取authList
    getAuthList: getAuthList,
    // 获取当前登录的thirdType
    getLoginedThirdType: function getLoginedThirdType() {
      return storage.get('thirdType');
    },
    // 异步判断是否登录
    isLoginAsync: isLoginAsync.install(config),
    // 异步判断是否绑定手机号
    isBindMobileAsync: isBindMobileAsync.install(config),
    // 获取动态配置
    getDefault: getDefault.install(config)
  };
};

var plugin = {};

plugin.install = function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // options = {
  //   userThirdScope: 'user_info',
  //   thirdType: 1 || 3 || 7,
  //   codeExtend: {}
  // }
  var conf = {
    value: account(options)
  }; // 实例挂载到vue

  Object.defineProperty(Vue, 'sdAccount', conf);
  Object.defineProperty(Vue.prototype, '$sdAccount', conf);
};

export default plugin;
